import { Component, Input, OnInit } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { AccountSelectors, CreditActivityActions, LocalizationSelectors, ModulesSelectors } from '@serviceos-ng/core';
import { finalize } from 'rxjs/operators';

@Component({
    selector: 'serviceos-web-account-credit',
    templateUrl: './account-credit.component.html',
    styleUrls: ['./account-credit.component.scss'],
})
export class AccountCreditComponent implements OnInit {
    @Select(AccountSelectors.getAvailableCredits)
    public availableCredits$;
    public isCreditEnabled = true;

    public documentDirection = '';

    @Input()
    viewType: "extended" | "compact" = 'extended';

    constructor(private store: Store) {
        this.store
            .dispatch(new CreditActivityActions.GetAll())
            // .pipe(finalize(() => {}))
            .subscribe();

        this.isCreditEnabled = this.store
        .selectSnapshot(ModulesSelectors.featureEnabled('credits', 'account')) || this.store
        .selectSnapshot(ModulesSelectors.featureEnabled('referral', 'account'))
        
    }

    ngOnInit(): void {
        this.store.select(LocalizationSelectors.getCurrentDirection()).subscribe(
            (currentDirection) => {
                if (currentDirection) {
                    this.documentDirection = currentDirection;
                }
            }
        )
    }
}
